import { BoxV2 as Box } from 'portal-commons';

const VARIANT_COLORS = {
  success: '#23B571',
  error: '#D41C62',
  neutral: '#B3B7B8',
} as const;

export default ({
  variant = 'error',
  color,
  size = '11px',
  shape = 'circle',
}: {
  variant?: 'success' | 'error' | 'neutral';
  color?: string;
  size?: string;
  shape?: 'circle' | 'square';
}) => {
  return (
    <Box
      as="span"
      sx={{
        bg: color || VARIANT_COLORS[variant] || VARIANT_COLORS.error,
        width: size,
        height: size,
        borderRadius: shape === 'circle' ? '50%' : '2px',
        display: 'inline-block',
        mr: 'xxs',
      }}
    />
  );
};
